import { FC } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import { Modal, TextLegacy } from '@/components/common'
import { NewCol } from '@/components/common/layouts/NewCol'
import { NewRow } from '@/components/common/layouts/NewRow'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { useModal, useUserInfo } from '@/containers/hooks'
import { doSetGlobalToastContent, doSetToggleModalLogin } from '@/stores/reduxUI'

type ReportProductReviewProps = {
  reviewId: string
}

const ReportProductReview: FC<ReportProductReviewProps> = ({ reviewId }) => {
  const dispatch = useDispatch()
  const { hasSignedIn } = useUserInfo
  const { useModalProps } = useModal()

  const onClick = (/*mutation: MutationFunction*/) => {
    if (!hasSignedIn()) {
      dispatch(doSetToggleModalLogin(true))
      return
    }

    useModalProps.showModal()
  }

  return (
    // <ApiMutation
    //   gqlKey='reportReview'
    // >
    //   { ( mutation: MutationFunction ) => (
    <>
      <NewRow justify="space-between" align="center">
        <StyledButton className="button" onClick={() => onClick(/*mutation*/)} color={GlobalColorEnum.Gray200}>
          <TextLegacy size={{ xs: 12, md: 14 }} color={'gray400'}>
            신고하기
          </TextLegacy>
        </StyledButton>
      </NewRow>
      <Modal
        useModalProps={useModalProps}
        buttonType="ACTION_CANCEL"
        okText="확인"
        onOk={() => {
          dispatch(
            doSetGlobalToastContent({
              content: '신고가 완료되었습니다.',
            })
          )
          // TODO: ReportReviewMutation 구현
          // const variables = MUTATION_VARIABLES.REPORT_REVIEW( { id: reviewId, user_id: userId } )
          // mutation( {
          //   variables
          // } )
        }}
        backAction={false}
        cancelText="취소"
      >
        <>
          <NewRow justify="center">
            <NewCol style={{ textAlign: 'center' }}>
              <TextLegacy size={{ xs: 16, md: 18 }} weight="bold" align="center">
                {'신고 하시겠습니까?'}
              </TextLegacy>
            </NewCol>
          </NewRow>
        </>
      </Modal>
    </>
    //   )}
    // </ApiMutation>
  )
}

const StyledButton = styled.div<{ color: string }>`
  border-radius: 4px;
  background-color: ${(props) => props.theme.color.grayWhite};
`
export default ReportProductReview
